export const EntityViewTab = {
    INVENTORY: 0,
    PHOTOS: 1,
    TASKS: 2,
};
